<template>
    <b-overlay class="h-100" :show="wait" rounded="sm">
        <preparations v-if="active_step == 'expensive_step1'" :id="id" :cost_data="cost_data.preparations" :objects_count="cost_data.total_objects" v-on:need_refresh="() => refresh()" />
        
        <objects v-if="active_step == 'expensive_step2'" :id="id" :group_id="group_id" :objects_count="cost_data.total_objects" :not_found_count="cost_data.not_found_count" :cost_evaluation="cost_evaluation_data" v-on:need_refresh="() => refresh()" />
        
        <profit v-if="active_step == 'expensive_step3_1'" :id="id" :data="cost_data.profit" v-on:set_value="(key, value) => set_value('profit.' + key, value)" v-on:need_refresh="() => refresh()" :not_editable="not_editable" />
            
        <wear v-if="active_step == 'expensive_step3_2'" :id="id" :data="cost_data.wear" v-on:set_value="(key, value) => set_value('wear.' + key, value)" v-on:need_refresh="() => refresh()" :not_editable="not_editable" />

        <setup_content v-if="active_step == 'expensive_step4'" title="Модель определения кадастровой стоимости" class="main-container">
            
            <formula :data="raw_formula" />

            <div class="mt-2 d-flex justify-content-center" style="gap: 16px">
                <b-button v-if="check_roles([ 'cost' ]) && !not_editable" class="d-flex align-items-center" style="gap: .25rem" variant="primary" v-on:click="calculate">
                    <base-icon name="calc"/>Рассчитать кадастровую стоимость
                </b-button>
            </div>

            <details_expensive ref="details" :group_id="group_id" type="Здание" />

        </setup_content>
    </b-overlay>
</template>

<script>

import objects from "./objects"
import formula from "./assets/formula"
import profit from "./profit"
import wear from "./wear"
import preparations from "./preparations"
import details_expensive from "./details"
import api from "../../../../../api"
import setup_content from "../setup_assets/content"

export default
{
    props:
    {
        id: String,
        data: Object,
        cost_evaluation_data: Object,
        group_id: String,
        not_editable : Boolean,
        active_step : String,
    },

    components:
    {
        objects,
        formula,
        profit,
        wear,
        preparations,
        details_expensive,
        setup_content,
    },
    
    data()
    {
        return {

			service : "cadastral_cost_evaluation",

            wait : false,

            cost_data :
            {
                total_objects : 0,
				not_found_count : null,
                preparations : 
                {
                    floors_above_ground : 0,
                    floors_under_ground : 0,
                    cs : 0,
                    capital_group : 0,
                    seismicity : 0,
                    price_zone : 0,
                    volume : 0,
                },
                profit :
                {
                    build_rate:
                    {
                        type : "Данные Пользователя",
                        custom : 
                        {
                            value : null,
                            source : "",
                        },
                        year_1: {
                            value : null,
                            source : "",
                        },
                        year_2: {
                            value : null,
                            source : "",
                        },
                        year_3: {
                            value : null,
                            source : "",
                        },
                        nominal: {
                            value : null,
                            source : "",
                        },
                        real: null,
                    },
                    inflation : [],
                    coef_1984 :
                    {
                        value : null,
                        source : ""
                    }
                },
                wear :
                {
                    type : "effective-age",
                    custom : 
                    {
                        value : null,
                        source : "",
                    },
                    external_wear_attr : "KLADR",
                    external_wear_items : [],
                    functional_wear_attr : "KLADR",
                    functional_wear_items : [],
                },
            },
            raw_formula :
            {
                label : "Общая формула",
                formula :
                [
                    { label : "Кадастровая стоимость = ЦОФ объекта оценки (ЦОФ_Площадь (кв. м), ", },
                    {
                        key : "construction_volume",
                        label : "Строительный объем",
                    },
					// { label : ", Основные характеристики / Площадь, Основные характеристики / Площадь застройки, Основные характеристики / Объем, Основные характеристики / Высота, Основные характеристики / Глубина, Основные характеристики / Протяженность) * Удельная стоимость справочная объекта-аналога * Поправка на объем или площадь * Поправка на класс конструктивной и системы или группы капитальности * Коэффициент сейсмичности * " },
                    { label : ", Основные характеристики / Площадь, Основные характеристики / Площадь застройки, Основные характеристики / Объем, Основные характеристики / Высота, Основные характеристики / Глубина, Основные характеристики / Протяженность) * Удельная стоимость справочная объекта-аналога * Поправка на класс конструктивной и системы или группы капитальности * Коэффициент сейсмичности * " },
                    {
                        key : "reg_coef",
                        label : "Региональный коэффициент",
                    },
                    { label : " * Коэффициент прибыли предпринимателя", },
                    // {
                    //     key : "coef_profit",
                    //     label : "[коэф-т ПП]",
                    // },
                    { label : " * ", },
                    {
                        key : "total_depreciation",
                        label : "(1-Совокупный износ)",
                    },
                ],
                descs :
                [
                    {
                        name : "Площадь или Строительный объем",
                        desc : "Исходные данные или Расчетная величина",
                    },
                    {
                        name : "Удельная стоимость справочная объекта-аналога",
                        desc : "Справочник объектов-аналогов",
                    },
					/*
                    {
                        name : "Поправка на объем или площадь",
                        desc : "Справочник «Поправки на площадь и объем»",
					},
					*/
                    {
                        name : "Коэффициент сейсмичности",
                        desc : "Справочник «Справочник сейсмичности»",
                    },
                    {
                        name : "Переход к дате оценки от даты справочника",
                        desc : "Коэффициенты для актуализации исходных справочников",
                    },
                    {
                        name : "Региональный коэффициент",
                        desc : "Расчетная величина",
                    },
                    {
                        name : "Коэффициент прибыли предпринимателя",
                        desc : "Расчетная величина",
                    },
                    {
                        name : "Совокупный износ",
                        desc : "Расчетная величина",
                    },
                ],
                variables :
                {
                    construction_volume : 
                    {
                        label : "Строительный объем",
                        formula :
                        [
                            {
                                label : "Площадь * (Высота этажа * Количество надземных этажей для расчета + Толщина перекрытия *(Количество надземных этажей для расчета + Количество подземных этажей для расчета) + Высота этажа подвала * Количество подземных этажей для расчета) / (Количество надземных этажей для расчета + Количество подземных этажей для расчета) * 1 / Коэффициент толщины стен"
                            },
                        ],
                        descs :
                        [
                            {
                                name : "Площадь",
                                desc : "Исходные данные",
                            },
                            {
                                name : `Высота этажа</br>
                                        Высота этажа подвала</br>
                                        Толщина перекрытия</br>
                                        Количество надземных этажей для расчета</br>
                                        Количество подземных этажей для расчета</br>
                                        Коэффициент толщины стен
                                        `,
                                desc : "Справочник «Данные для расчета строительного объема»",
                            },
                        ],
                    },
                    reg_coef :
                    {
                        label : "Региональный коэффициент",
                        formula : 
                        [
                            {
                                label : "Региональный коэффициент = Кпер * Кпер/зон * Kрег",
                            },
                        ],
                        descs :
                        [
                            {
                                name : "Коэффициенты Кпер., Кпер/зон, Крег",
                                desc : "Приведенные в Таблицах 1 и 2, предусматриваются в целях перехода от цен базового района (Московская область) к уровню цен субъектов Российской Федерации",
                            },
                        ],
                    },
                    // coef_profit :
                    // {
                    //     label : "[коэф-т ПП]",
                    //     formula : 
                    //     [
                    //         { label : "Значение выбирается по характеристике «Период строительства, квартал» из справочника «Расчет прибыли предпринимателя»<br>", },
                    //         {                                        
                    //             key : "residential_building",
                    //             label : "Для жилых зданий ",
                    //         },
                    //         {
                    //             key : "non_residential_building",
                    //             label : "Для нежилых зданий",
                    //         },
                    //     ],
                    //     desc :
                    //     [
                    //         {
                    //             name : "Расчет периода строительства",
                    //             desc : "Расчет продолжительности строительно-монтажных и проектно-изыскательских работ",
                    //         },
                    //     ],
                    //     variables :
                    //     {
                    //         residential_building :
                    //         {
                    //             label : "Для жилых зданий",
                    //             formula : 
                    //             [
                    //                 { label : "Cогласно Приложению № 10 к Методическим указаниям о ГКО продолжительность строительно-монтажных работ определяется по формуле:"},
                    //                 { formula_name : "residential", }
                    //             ],
                    //             descs :
                    //             [
                    //                 {
                    //                     name : "Тн",
                    //                     desc : "Продолжительность строительно-монтажных работ (СМР), мес.",
                    //                 },
                    //                 {
                    //                     name : "S",
                    //                     desc : "Площадь объекта (кв. м)",
                    //                 },
                    //             ],
                    //         },
                    //         non_residential_building :
                    //         {
                    //             label : "Для нежилых зданий",
                    //             formula : 
                    //             [
                    //                 { label : "Расчетный метод определения общей продолжительности строительства основан на функциональной зависимости продолжительности строительства от стоимости СМР в ценах 1984 года.<br>Такая зависимость выражается в виде функций:"},
                    //                 { formula_name : "non_residential_1", },
                    //                 { formula_name : "non_residential_2", },
                    //                 { formula_name : "non_residential_3", },
                    //             ],
                    //             descs :
                    //             [
                    //                 {
                    //                     name : "С",
                    //                     desc : "Объем строительно-монтажных работ в ценах 1984 года (млн. руб.)",
                    //                 },
                    //                 {
                    //                     name : "A<sub>1</sub>, А<sub>2</sub>",
                    //                     desc : "Параметры регрессионной кривой, определяемые методом наименьших квадратов (значения коэффициентов приведены в таблице в Приложении 10 к Методическим указаниям о ГКО)",
                    //                 },
                    //             ],
                    //         },
                    //     }
                    // },
                    total_depreciation :
                    {
                        label : "Совокупный износ",
                        formula : 
                        [
                            {
                                label : "Совокупный износ = 1 - (1-",
                            },
                            {
                                // key : "physical_depreciation",
                                label : "Физический износ",
                            },
                            {
                                label : ") * (1-Внешнее устаревание) * (1-Функциональное устаревание)",
                            },
                        ],
                        descs :
                        [
                            {
                                name : "Физический износ",
                                desc : "Расчетная величина",
                            },
                            {
                                name : "Внешнее устаревание",
                                desc : "Справочник населенных пунктов",
                            },
                            {
                                name : "Функциональное устаревание",
                                desc : "Справочник населенных пунктов",
                            },
                        ],
                        // variables :
                        // {
                        //     physical_depreciation :
                        //     {
                        //         label : "Физический износ",
                        //         formula : 
                        //         [
                        //             { label : "Физический износ = ([Дата оценки]-[Год завершения строительства]&[Год ввода в эксплуатацию]) /[#'Срок экономической жизни']"}
                        //         ],
                        //         descs :
                        //         [
                        //             {
                        //                 name : "([Дата оценки]-[Год завершения строительства]&[Год ввода в эксплуатацию]) /",
                        //                 desc : "Исходные данные",
                        //             },
                        //             {
                        //                 name : "[#'Срок экономической жизни']",
                        //                 desc : "Справочник «Срок экономической жизни для зданий»",
                        //             },
                        //         ],
                        //     },
                        // }
                    },
                    
                }
            },

        }
    },

    mounted()
    {
        this.refresh()
    },

    methods :
    {
        refresh()
        {
            // this.wait = true

			api.call(this, this.service, "get", { id : this.id },
				response =>
				{
					this.cost_data = response.data.comparative_element
					this.wait = false
				})
        },

		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

        set_value(key, value)
        {
            if (this.check_roles([ 'model' ]) && !this.not_editable)
            {
                api.call(this, this.service, "set_field", { id : this.id, field : "comparative_element." + key, value : value }, () => {
                    api.show_notification(this, "Изменения сохранены")
                    this.refresh()
                })
            }
        },

		calculate()
		{
            if (this.check_roles([ 'cost' ]))
            {
                api.call_long_operation(this, "Группа / Множественное редактирование / Расчеты / Расчет кадастровой стоимости", "cadastral_groups", "set_cost", { id : this.group_id, calculation_types : [ "Затратный подход" ], evaluate_result_cost : false },
                    response =>
                    {
                        api.open_response_url(response)

                        this.$refs.details.refresh()
                    },
                    { success_msg : "Расчет КС завершен" }
                )
            }
		},
    }
}
</script>
